var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('tinymce',{attrs:{"api-key":"ol1x2psd36c8v9qraeqwp7u9wrzvk39fxswb2dkyp7qfoebq","init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }